import { Hospital } from 'domain/entities/hospital-model'
import { AddDoctor } from 'domain/usecases/doctor/add-doctor'
import AddDoctorLayout from 'presentation/hospital/layouts/AddDoctor'
import React, { useEffect, useState } from 'react'
import { useStores } from 'presentation/hooks/use-stores'

type AddDoctorProps = {
  addDoctor: AddDoctor
}

export default function HospitalAddDoctor({ addDoctor }: AddDoctorProps) {
  const [hospitals, setHospitals] = useState([] as Hospital[])
  const [isLoading, setIsLoading] = useState(true)

  const currentHospital = useStores().currentHospital

  useEffect(() => {
    const loadData = async () => {
      await currentHospital.load()
      setHospitals(currentHospital.hospitalList)
    }
    loadData()
    setIsLoading(false)
  }, [])

  if (isLoading) {
    return <></>
  } else {
    return <AddDoctorLayout hospitals={hospitals} addDoctor={addDoctor} />
  }
}
